<template>
  <div class="section-category section-full" @scroll="onScroll">
    <h2 class="ttl2 popup-header" v-translate >stock delivery</h2>
    <div class="input-group mb-3 col-3 float-right">
      <input type="text" class="form-control" id="input-search" v-model="filterByName" placeholder="Search by article name..." aria-label="Recipient's username" aria-describedby="basic-addon2">
    </div>
    <div class="inner-delivery popup-content" >
      <table class="table">
        <thead>
          <tr>
            <th class="text-left" width="160px">
              <v-select :class="{'no-show': !showDropdown, 'custom-select-filter': true}"
                  v-model="filter.category"
                  :options="managementGroups"
                  :ref="'category'"
                  label="name"
                  :placeholder="$gettext('Management Group')"
                  @search:focus="onFocus('category')"
                  @search="onSearch"
                >
                  <template slot="no-options">
                    {{ $gettext('No results found') }} ..
                  </template>
                  <template slot="option" slot-scope="option">
                    <div class="d-center">
                      {{ option.name }}
                    </div>
                  </template>
                  <template slot="selected-option" slot-scope="option">
                    <div class="selected d-center">
                      {{ option.name }}
                    </div>
                  </template>
                </v-select>
            </th>
            <th class="text-left" v-translate>Article Name</th>
            <th class="text-center" v-translate>Alarm Level</th>
            <th class="text-center" v-translate>Standard Order</th>
            <th v-translate>Buying Price</th>
            <th v-translate>Size</th>
            <th v-translate>Count</th>
            <th v-translate>Current Count</th>
            <th v-translate>Put in</th>
            <th style="width: 130px" v-translate>Delivery</th>
            <!--
            <th width="140px">Location</th>
            -->
          </tr>
        </thead>
        <tbody v-if="deliveries" :key="counter">
          <tr v-for="item in stockItemFiltered" :key="item.id" >
            <td class="text-left">{{ printName(item.managementGroup, 'managementGroups') }}</td>
            <td class="text-left">{{ item.name }}</td>
            <td>{{ item.alarmLevel }}</td>
            <td>{{ item.standardOrder }}</td>
            <td>{{ item.cost | currency}}</td>
            <td>{{ item.size }} {{ printName(item.unit, 'units') }}</td>
            <td>{{ printName(item.count, 'counts') }}</td>
            <td v-if="!deliveries[item.id]"></td>
            <td v-else>
              {{ deliveries[item.id]['currentCount'] || 0 | decimal(true) }}
            </td>
            <td v-if="relatedStations.length < 2">{{ station.name }}</td>
            <td v-else>
              <select 
                v-if="deliveries[item.id]"
                v-model="deliveries[item.id]['station']" 
                name="targetStock[]"
                @change="getStock(item.id)"
                style="max-width: 80px;"
              >
                <option v-for="station in relatedStations" :key="station.id" :value="station.id">{{ station.name }}</option>
              </select>
            </td>
             <td>
              <input-pad
                v-if="deliveries[item.id]"
                :item="deliveries[item.id]"
                :property="'modifyCount'"
                :id="'stock-item-delivery'"
                :attributes="{'class': 'delivery'}"
                :usingDecimal="true"
                />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="btn-confirm-undo popup-action" :style="{'top': scrollTop}">
      <button type="button" class="btn btn-confirm" @click="submitDelivery()" v-translate>Confirm</button>
      <button type="button" class="btn btn-cancel" @click="$router.go(-1)" v-translate>Cancel</button>
<!--      <button type="button" class="btn btn-undo" @click="undo()" v-translate>Undo</button>-->
    </div>
  </div>
</template>

<script>
import StockService from '@/services/StockService';
import CategoryService from '@/services/CategoryService';
import { mapState, mapMutations } from 'vuex';
import { ON_INPUT_PAD_BLUR } from '@/store/mutation-types';

export default {
  name: 'StockDelivery',
  data() {
    return {
      scrollTop: 0,
      showDropdown: false,
      filterByName: '',
      filter: {
        category: null,
      },
      select: {
        category: null,
        current: null,
      },
      counter: 0
    };
  },
  computed: {
    inputPadUpdate: {
      get() { return this.getMap('inputHolderFocusing', true); },
      set(value) { this.$store.state.inputPad.inputHolderFocusing = value; },
    },
    relatedStations() {
      return this.getArray('stations', true).filter(station => station.location == this.station.location);
    },
    managementGroups() {
      const vary = this.inputPadUpdate;
      return this.getArray('managementGroups');
    },
    stockItems() {
      const stockItems = [];
      const stockItemMasterList = this.getArray('stockItems', false, true);
      const stockItemCloneList = this.$store.getters.getCloneStockItemList;
      stockItemMasterList.forEach((stockItem) => {
        const clone = this.$store.getters.getStockItemClone(stockItem, stockItemCloneList);
        if(clone) {
          if(clone.active) {
            stockItems.push(clone);
          }
        } else {
          stockItems.push(stockItem);
        }
      });
      return stockItems;
    },
    stockItemFiltered() {
      const stockItems = this
        .stockItems
        .filter(
          item => (this.filter.category
            ? (this.filter.category.id === item.managementGroup
                            || (this.deliveries[item.id] && this.deliveries[item.id].modifyCount))
            : true),
        );

      return stockItems.filter(item => item.name.toLowerCase().indexOf(this.filterByName.toLowerCase()) > -1);
    },
    station() { return this.getMap('user', true).station; },
    deliveries: {
      get() { return this.$store.state.stock.deliveries },
      set(value) {
        this.$store.state.stock.deliveries = value
      }
    }
  },
  methods: {
    async submitDelivery() {
      const stockData = {}
      let noData = true
      for (const stockItemId in this.deliveries) {
        const delivery = this.deliveries[stockItemId]
        if(!delivery.modifyCount) continue;
        if(!delivery.station) continue;
        if(!stockData[delivery.station]) {
          stockData[delivery.station] = {
            station: delivery.station,
            stocks: [],
          }
        }
        stockData[delivery.station].stocks.push({
          id: delivery.id || 0,
          station: delivery.station,
          stockItem: parseInt(stockItemId),
          currentCount: 1 * delivery.modifyCount,
        })
        noData = false
      }
      if(noData) return
      const response = await StockService.newDelivery(stockData);
      if(response.result 
        && response.result === 'success'
        && response.modifiedStocks
      ) {
        response.modifiedStocks.forEach( stock => {
          this.deliveries[stock.stockItem] = {
            station: stock.station,
            currentCount: stock.currentCount,
            modifyCount: '',
            id: stock.id
          };
        })
      }
      this.inputPadUpdate = 1;
    },
    onScroll(event) {
      this.scrollTop = `${event.target.scrollTop}px`;
      this.$store.commit(ON_INPUT_PAD_BLUR, true);
    },
    onFocus(selectId) {
      this.select[selectId] = null;
      this.filter[selectId] = null;
      this.select.current = selectId;
      this.showDropdown = this.$refs[selectId].mutableOptions.length > 0;
    },
    onSearch(search) {
      this.select[this.select.current] = search;
    },
    async getStock(stockItemId) {
      const currentStock = this.deliveries[stockItemId];
      const response = await StockService.getStock(stockItemId, currentStock['station']);
      currentStock['currentCount'] = parseFloat(response.currentCount)
      currentStock['id'] = parseInt(response.id)
      this.counter++
    },
    async initStocksForm() {
      this.deliveries = {};
      const currentStationStockMap = await StockService.getStock(0, this.station.id);
      this.stockItems.forEach((stockItem) => {
        const stock = {
          station: this.station.id,
          currentCount: null,
          modifyCount: '',
          id: 0
        };
        if(currentStationStockMap[stockItem.id]) {
          stock.currentCount = currentStationStockMap[stockItem.id].currentCount
          stock.id = currentStationStockMap[stockItem.id].id
        }
        this.deliveries[stockItem.id] = stock
      });
      this.counter++
    }
  },
  watch: {
    stockItems: {
      handler(value) {
        this.initStocksForm()
      }
    },
  }
};
</script>
<style lang="scss">
  #input-search::placeholder {
      font-style: italic !important;
  }
</style>
